import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
import create from "../../create";
import axios from 'axios';
export default create({
  name: "map",
  data: function data() {
    return {
      bannerCount: 0,
      bannerCheck: "",
      centerData: [],
      zoomData: 1
    };
  },
  watch: {
    mapData: function mapData() {
      this.updateChart();
    },
    dataChartLen: function dataChartLen() {
      this.setBanner();
    },
    bannerTime: function bannerTime() {
      this.setBanner();
    },
    banner: {
      handler: function handler() {
        this.setBanner();
      },
      immediate: true
    },
    width: function width() {
      this.updateData();
    },
    height: function height() {
      this.updateData();
    },
    zoom: {
      handler: function handler() {
        this.zoomData = this.zoom;
      },
      immediate: true
    }
  },
  computed: {
    zoomShow: function zoomShow() {
      return this.option.zoomShow || 1;
    },
    zoom: function zoom() {
      return this.option.zoom || 1;
    },
    mapData: function mapData() {
      return this.option.mapData || {};
    },
    borderWidth: function borderWidth() {
      return this.option.borderWidth || 3;
    },
    borderColor: function borderColor() {
      return this.option.borderColor || "#389BB7";
    },
    areaColor: function areaColor() {
      return this.option.areaColor || "#0c162f";
    },
    empColor: function empColor() {
      return this.option.empColor || "#fff";
    },
    empAreaColor: function empAreaColor() {
      return this.option.empAreaColor || "yellow";
    },
    color: function color() {
      return this.option.color || "#fff";
    },
    roam: function roam() {
      return this.vaildData(this.option.roam, true);
    },
    fontSize: function fontSize() {
      return this.option.fontSize || 24;
    },
    bannerTime: function bannerTime() {
      return this.option.bannerTime || 3000;
    },
    banner: function banner() {
      return this.option.banner;
    },
    locationData: function locationData() {
      var _this = this;

      return (this.dataChart || []).map(function (ele) {
        ele.zoom = ele.zoom || 1;
        var zoomData = _this.zoomData < 1 ? 1 : _this.zoomData;
        return Object.assign(function () {
          if (ele.zoom <= zoomData) {
            return {
              name: ele.name
            };
          }

          return {};
        }(), {
          value: [ele.lng, ele.lat, ele.value]
        });
      });
    }
  },
  methods: {
    resetBanner: function resetBanner() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.myChart.dispatchAction({
          type: "hideTip"
        }); // this.myChart.dispatchAction({
        //   type: "downplay"
        // });

      });
    },
    setBanner: function setBanner() {
      var _this3 = this;

      clearInterval(this.bannerCheck);

      if (this.banner) {
        this.bannerCheck = setInterval(function () {
          var curr = _this3.bannerCount % _this3.dataChartLen;

          _this3.myChart.dispatchAction({
            type: "showTip",
            seriesIndex: "0",
            dataIndex: curr
          });

          _this3.myChart.dispatchAction({
            type: "downplay"
          });

          _this3.myChart.dispatchAction({
            type: "highlight",
            dataIndex: curr
          });

          _this3.bannerCount += 1;
        }, this.bannerTime);
      }
    },
    updateChart: function updateChart() {
      var _this4 = this;

      axios(this.mapData).then(function (res) {
        var _Object$assign;

        console.log('res', res);
        var data = res;

        var optionData = _this4.deepClone(data);

        window.echarts.registerMap("HK", optionData);
        var option = {
          tooltip: function () {
            return Object.assign(function () {
              if (_this4.formatter) {
                return {
                  formatter: function formatter(name) {
                    return _this4.formatter(name, _this4.dataChart);
                  }
                };
              }

              return {};
            }(), {
              backgroundColor: _this4.option.tipBackgroundColor || "rgba(0,0,0,1)",
              textStyle: {
                fontSize: _this4.option.tipFontSize,
                color: _this4.option.tipColor || "red"
              }
            });
          }(),
          geo: Object.assign(function () {
            if (!_this4.validatenull(_this4.centerData)) {
              return {
                center: _this4.centerData
              };
            }

            return {};
          }(), (_Object$assign = {
            map: "HK",
            label: {
              emphasis: {
                show: false
              }
            },
            zoom: _this4.zoomData,
            layoutCenter: ["50%", "50%"],
            layoutSize: 1200,
            roam: _this4.roam
          }, _defineProperty(_Object$assign, "label", {
            show: true,
            fontSize: _this4.fontSize,
            color: _this4.color
          }), _defineProperty(_Object$assign, "left", _this4.option.gridX), _defineProperty(_Object$assign, "top", _this4.option.gridY), _defineProperty(_Object$assign, "right", _this4.option.gridX2), _defineProperty(_Object$assign, "bottom", _this4.option.gridY2), _defineProperty(_Object$assign, "emphasis", {
            label: {
              color: _this4.empColor
            },
            itemStyle: {
              areaColor: _this4.empAreaColor
            }
          }), _defineProperty(_Object$assign, "itemStyle", {
            borderWidth: _this4.borderWidth,
            borderColor: _this4.borderColor,
            areaColor: _this4.areaColor
          }), _Object$assign)),
          series: [{
            type: "effectScatter",
            coordinateSystem: "geo",
            showEffectOn: "emphasis",
            rippleEffect: {
              brushType: "fill",
              scale: 4
            },
            symbolSize: _this4.fontSize,
            hoverAnimation: true,
            data: _this4.locationData,
            label: {
              show: true,
              position: ["130%", "0"],
              fontSize: _this4.fontSize,
              color: _this4.color,
              formatter: function formatter(params) {
                return params.name;
              }
            },
            itemStyle: {
              color: _this4.color
            },
            emphasis: {
              label: {
                show: true,
                fontSize: _this4.fontSize + 20,
                color: _this4.option.empColor
              },
              itemStyle: {
                color: _this4.option.empColor
              }
            }
          }]
        };

        _this4.myChart.off("mouseover");

        _this4.myChart.off("mouseout");

        _this4.myChart.off("georoam");

        _this4.myChart.on("mouseover", function () {
          clearInterval(_this4.bannerCheck);

          _this4.resetBanner();
        });

        _this4.myChart.on("mouseout", function () {
          _this4.bannerCount = 0;

          _this4.setBanner();
        });

        _this4.myChart.on("georoam", function (e) {
          var option = _this4.myChart.getOption();

          var geo = option.geo[0];
          _this4.centerData = geo.center;
          _this4.zoomData = geo.zoom;
          if (_this4.zoomData < 1) _this4.zoomData = 1;
        });

        _this4.myChart.resize();

        _this4.myChart.setOption(option, true);
      });
    }
  }
});